export default function PreviousPageIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="9"
      height="13"
      viewBox="0 0 9 13"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.8814 11.8859C7.42378 12.3757 6.66969 12.3757 6.21207 11.8859L0.86695 6.16488L0.895977 6.13381L0.86695 6.10274L6.21207 0.381753C6.66969 -0.108045 7.42378 -0.108045 7.8814 0.381753C8.32339 0.854824 8.32339 1.60972 7.8814 2.08279L4.09653 6.13381L7.8814 10.1848C8.32339 10.6579 8.32339 11.4128 7.8814 11.8859Z"
        fill="currentColor"
      />
    </svg>
  );
}
